export default {
  allContracts: (state) => state.contracts,
  focusedContractId: (state) => state.focusedContractId,
  selectedContractId: (state) => state.selectedContractId,
  contractsLoading: (state) => state.contractsLoading,
  filter: (state) => state.filter
}
